import React from "react";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartPlus, faShoppingBag, faPlus, faMinus, faTrash, } from "@fortawesome/pro-light-svg-icons";
//## redux ##//
import carritoSlice from "../../../../../redux/data/carrito";
import { useAppSelector } from "../../../../../hooks/customReduxHooks";
import LoadstoneService from "../../../../../redux/services/loadstone";
import { BotonAgregarAlCarrito, BotonMasInformacion, BotonRestarAlCarrito, BotonSumarAlCarrito, ControladorDeCantidades, } from "./ControladorCantidadEnCarritoStyled";
var ControladorCantidadEnCarrito = function (_a) {
    var producto = _a.producto, contextoVisual = _a.contextoVisual;
    var dispatch = useDispatch();
    var setCantidadProductoEnCarrito = carritoSlice.actions.setCantidadProductoEnCarrito;
    var productosEnCarritoState = useAppSelector(function (state) { return state.carrito.productosEnCarrito; });
    var infoProductoDesdeState = productosEnCarritoState.find(function (item) { return item.id === producto.id; });
    var globalConfig = useAppSelector(function (state) { return state.empresa && state.empresa.globalConfig; });
    var AddToCartRetailRocket = function () {
        if (producto.vitrinaLoadStone) {
            LoadstoneService.postLoadstone({
                productId: producto.id,
                recomBlockId: producto.recomBlockId,
                type: "recomAddToBasket",
            });
        }
        else {
            LoadstoneService.postLoadstone({
                productId: producto.id,
                type: "addToBasket",
            });
        }
    };
    var agregarAlCarrito = function (e) {
        e.stopPropagation();
        AddToCartRetailRocket();
        dispatch(setCantidadProductoEnCarrito({ accion: "AGREGAR", id: producto.id }));
    };
    var handleBotonRestarAlCarrito = function (e) {
        e.stopPropagation();
        dispatch(setCantidadProductoEnCarrito({
            accion: "QUITAR",
            id: producto.id,
            stock: producto.stock,
        }));
    };
    var handleBotonSumarAlCarrito = function (e) {
        e.stopPropagation();
        if (infoProductoDesdeState.cantidad < producto.stock) {
            dispatch(setCantidadProductoEnCarrito({
                accion: "AGREGAR",
                id: producto.id,
            }));
        }
    };
    if (contextoVisual && contextoVisual === "top10")
        return React.createElement(React.Fragment, null);
    return producto.estado == "1" && producto.visibilidad == "4" ? (
    //Esto es cuando el producto tiene stock y esta pausado.
    React.createElement(BotonMasInformacion, { href: producto.urlseo }, "No disponible")) : //Esto es cuando el producto tiene stock y a su vez no tiene fecha de lanzamiento.
        producto.estado == "1" && !producto.producto_no_disponible ? (infoProductoDesdeState && infoProductoDesdeState.cantidad > 0 ? (React.createElement(ControladorDeCantidades, { contextoVisual: contextoVisual },
            React.createElement(BotonRestarAlCarrito, { contextoVisual: contextoVisual, onClick: handleBotonRestarAlCarrito }, infoProductoDesdeState.cantidad === 1 ? (React.createElement(FontAwesomeIcon, { icon: faTrash })) : (React.createElement(FontAwesomeIcon, { icon: faMinus }))),
            React.createElement("span", null, infoProductoDesdeState && infoProductoDesdeState.cantidad),
            React.createElement(BotonSumarAlCarrito, { contextoVisual: contextoVisual, disabled: infoProductoDesdeState.cantidad >= producto.stock, onClick: handleBotonSumarAlCarrito },
                React.createElement(FontAwesomeIcon, { icon: faPlus })))) : (React.createElement(BotonAgregarAlCarrito, { contextoVisual: contextoVisual, onClick: agregarAlCarrito },
            contextoVisual === "hotSale" ? (React.createElement(FontAwesomeIcon, { icon: globalConfig.hotSale.iconoHotSale })) : globalConfig.iconoDeCarrito === "cart" ? (React.createElement(FontAwesomeIcon, { icon: faCartPlus })) : (React.createElement(FontAwesomeIcon, { icon: faShoppingBag })),
            "Agregar"))) : (
        //Esto es cuando el producto no tiene stock.
        React.createElement(BotonMasInformacion, { href: producto.urlseo, contextoVisual: contextoVisual }, "M\u00E1s informaci\u00F3n"));
};
export default ControladorCantidadEnCarrito;
